import { safeDefine } from "../../registration/safe-define.js";
import { DialogBackdropElement } from "../../ui/dialog/backdrop.js";
//#region src/define/ui/dialog-backdrop.ts
safeDefine(DialogBackdropElement);
//#endregion

//# sourceMappingURL=dialog-backdrop.js.map